import axios, { AxiosRequestConfig } from 'axios';
import { PublicSitterList } from '../types/PublicSitter';
import { DataResponse } from '../types/api';

const URL = '/v2/public/sitters';

class PublicSitterService {
  static getByFilter(config?: AxiosRequestConfig):
    Promise<DataResponse<PublicSitterList>> {
    return axios.get(URL, config);
  }
}

export { PublicSitterService }
